import React from "react";
import PropTypes from "prop-types";
import { Stack } from "@mui/material";
import Markdown from "@/components/Markdown";
import PageContainer from "@/components/pages/COA/PageContainer";
import Title2 from "@/components/pages/COA/Title2";
import Description from "@/components/pages/COA/Description";

const HowToGetStarted = ({ styles, howToGetStarted }) => (
  <Stack
    className={styles.howToGetStartedWrapper}
    sx={{
      backgroundImage: `url(${howToGetStarted.backgroundImage.publicURL})`
    }}
  >
    <PageContainer sx={{ paddingX: 0 }}>
      <div className={styles.howToGetStartedContainer}>
        <Title2 white>{howToGetStarted.title}</Title2>
        <Description white className={styles.howToGetStartedDescription}>
          {howToGetStarted.description}
        </Description>
        <a
          href={howToGetStarted.ctaLink}
          className={styles.howToGetStartedButton}
        >
          <Markdown>{howToGetStarted.ctaText}</Markdown>
          <span>
            <i className="fa fa-chevron-right" aria-hidden="true" />
          </span>
        </a>
      </div>
    </PageContainer>
  </Stack>
);

HowToGetStarted.propTypes = {
  styles: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  howToGetStarted: PropTypes.shape({
    backgroundImage: PropTypes.shape({
      publicURL: PropTypes.string.isRequired
    }).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    ctaLink: PropTypes.string.isRequired,
    ctaText: PropTypes.string.isRequired
  }).isRequired
};

export default HowToGetStarted;
